import React from 'react';
import PropTypes from 'prop-types';
import LoadMore from './icons/LoadMore';
import { Button } from "src/components/ui/button";

const LoadMoreButton = ({ label, onClick, isLoading, disabled }) => {
  return (
    <Button
      variant="outline"
      onClick={onClick}
      disabled={disabled} // Prevent multiple API calls
      className={`mt-3 border-gray-100 rounded-[34px] text-gold-300 flex gap-1.5 items-center 
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gold-50'}`}
    >
      {isLoading && <LoadMore className="animate-spin" />} {/* Spinner only on click */}
      <span className="text-base font-semibold leading-5">
        {isLoading ? "Loading..." : label}
      </span>
    </Button>
  );
};

LoadMoreButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
  onClick: () => {},
  isLoading: false,
  disabled: false,
};

export default LoadMoreButton;
